const userInfo = {
  // 代码仓不允许明文存储用户信息，实际开发请本地填写，不要提交该文件到gitlab仓库
  openId: "", // （微信有）
  unionid: "", // （微信有）
  alipayUserId: "", // 支付宝用户ID（支付宝有）
  memberCenterId: "", // 会员ID（支付宝+微信有）
  member: true, // 是否是会员（支付宝+微信小程序已登录：true, 其他：false）
  // AT（支付宝+微信有）
  accessToken: "",
  // UT（支付宝+微信有）
  userToken: ""
};

export default userInfo;



// WEBPACK FOOTER //
// ./src/api/localDevConfig.js